import Crud from '../views/MotivoTransporte/Crud'
import Entity from '../views/MotivoTransporte/Add'

let routes = {
    path: '/motivo_transporte',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/motivo_transporte/add',
            name: 'NewMotivo',
            component: Entity
        },
        {
            path: '/motivo_transporte/edit/:id?',
            name: 'EditMotivo',
            component: Entity
        },
        {
            path: '/motivo_transporte',
            name: 'list-motivo-transporte',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Motivos',
                breadcrumb: [
                    {
                        text: 'Motivos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
